// extracted by mini-css-extract-plugin
module.exports = {"grid":"Tours_grid__JZ6gC","gridItem":"Tours_gridItem__a84wG","isExpanded":"Tours_isExpanded__rr6DN"};